<template>
  <confirm-dialog ref="dialog" :title="'Fake Trace'" :confirmCb="confirmChange" :cancelCb="cancelCb" :width="55" :loading="loading">
    <template v-slot:content>
      <json-editor-vue v-model="fakeTrace" mode="text" :mainMenuBar="false" />
    </template>
  </confirm-dialog>
</template>
<script>
import ConfirmDialog from '@/components/common/Confirm.vue'
import JsonEditorVue from 'json-editor-vue'
import {
  updateTrackingRecord
} from '@/api/tracking'
export default {
  name: 'FakeTraceDialog',
  components: {
    ConfirmDialog,
    JsonEditorVue
  },
  props: {
    successCb: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      shipmentId: '',
      recordId: '',
      fakeTrace: '',
      loading: false
    }
  },
  methods: {
    open(
      shipmentId,
      recordId,
      fakeTrace
    ) {
      this.shipmentId = shipmentId
      this.recordId = recordId
      this.$set(this, 'fakeTrace', fakeTrace)
      this.$refs.dialog.open()
    },
    confirmChange(close, error) {
      if (this.fakeTrace === '' || this.fakeTrace == null) {
        error('content is empty')
        return
      }
      let fakeTrace = ''
      try {
        fakeTrace = typeof this.fakeTrace === 'string' ? JSON.parse(this.fakeTrace) : this.fakeTrace
      } catch (e) {
        error('invalid json format')
      }
      const data = {
        shipmentId: this.shipmentId,
        recordId: this.recordId,
        fakeTrace
      }
      this.loading = true
      updateTrackingRecord(data)
        .then(() => {
          close()
          this.successCb()
        })
        .catch(err => {
          error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelCb() {
      this.reset()
    },
    reset() {
      this.shipmentId = ''
      this.recordId = undefined
      this.fakeTrace = ''
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.tracking-record-new-wrapper {
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: row;
}
</style>
